import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "../../data/promill";

export const Testimonials = () => (
    <section
        data-testid="testimonials-section"
        className="bg-pm-green text-white py-20 md:py-28 relative overflow-hidden"
    >
        <div aria-hidden className="absolute inset-0 opacity-[0.07] pattern-bolts" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mb-14">
                <span className="inline-block text-pm-yellow font-bold tracking-[0.3em] uppercase text-xs mb-4">
                    Loved by India
                </span>
                <h2 className="font-display text-5xl md:text-7xl uppercase leading-[0.95]">
                    The hustle <span className="text-pm-yellow">approves.</span>
                </h2>
            </div>

            <div className="grid md:grid-cols-3 gap-7">
                {TESTIMONIALS.map((t, i) => (
                    <figure
                        key={t.name}
                        data-testid={`testimonial-${i}`}
                        className="relative bg-pm-greenBright/30 backdrop-blur-sm border-2 border-pm-yellow/40 rounded-2xl p-7 card-lift"
                    >
                        <Quote className="w-10 h-10 text-pm-yellow mb-4" />
                        <blockquote className="text-lg leading-relaxed">"{t.quote}"</blockquote>
                        <div className="mt-6 flex items-center gap-3">
                            <div className="h-12 w-12 rounded-full bg-pm-yellow text-pm-green flex items-center justify-center font-display text-2xl border-2 border-pm-black">
                                {t.name.charAt(0)}
                            </div>
                            <figcaption>
                                <div className="font-display text-xl uppercase tracking-wider">{t.name}</div>
                                <div className="text-xs uppercase tracking-[0.2em] text-white/70">{t.role}</div>
                            </figcaption>
                            <div className="ml-auto flex">
                                {[...Array(5)].map((_, idx) => (
                                    <Star key={idx} className="w-4 h-4 fill-pm-yellow text-pm-yellow" />
                                ))}
                            </div>
                        </div>
                    </figure>
                ))}
            </div>
        </div>
    </section>
);
